module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-07transporte-de-mercancias.ba710738.jpg";